module.exports = __webpack_public_path__ + "static/media/studentSubscriptionbanner.f099fd13.png";